import { render, staticRenderFns } from "./v-searchable-select-shallow.vue?vue&type=template&id=319e3b80&scoped=true&"
import script from "./v-searchable-select-shallow.vue?vue&type=script&lang=js&"
export * from "./v-searchable-select-shallow.vue?vue&type=script&lang=js&"
import style0 from "./v-searchable-select-shallow.vue?vue&type=style&index=0&id=319e3b80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319e3b80",
  null
  
)

export default component.exports